import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";
import { ToasterContext } from "contexts/ToasterContext";
import Modal from "components/UI/Modal";
import UserForm from "components/Users/UserForm";
import withAuth from "withAuth";

import "./Users.scss";

const Users = () => {
  const { dispatch } = useContext(ContextOne);
  const { AddToast } = useContext(ToasterContext);

  const [users, setUsers] = useState([]);
  const [showUserForm, setShowUserForm] = useState(false);

  // Data Fetching

  const fetchUsers = async () => {
    const data = await ApiService.getUsers();
    setUsers(data);
  };

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    await fetchUsers();

    dispatch({ type: "loading", val: false });
  };

  // Routing

  let navigate = useNavigate();

  const routeToUser = (uuid) => {
    let path = `/users/${uuid}`;
    navigate(path);
  };

  const handleUserSubmit = async (user) => {

    dispatch({ type: "loading", val: true });

    AuthService.fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/users/add_user`, {
        method: "POST",
        body: JSON.stringify({
          email: user.email
        })
      }
    )
    .then(
      async () => {
        await fetchData();
        AddToast("success", "User added", null);
        return;
      },
      (error) => {
        AddToast("danger", null, error);
        return;
      }
    )
    .then(() => {
      dispatch({ type: "loading", val: false });
      setShowUserForm(false);
    })
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  /*
  const handleUserShowModal = (event) => {
    event.preventDefault();

    setShowUserForm(true);
  };
  */

  const handleUserCloseModal = (_event) => {
    setShowUserForm(false);
  };

  return (
    <div className="users-component">
      <div className="text-center">
        <div className="users-header">
          <div className="title">
            <h1>Users</h1>
          </div>
        </div>
        <table className="table tbl-striped table-sm">
          <thead>
            <tr>
              <th>Username</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Status</th>
              <th>Admin?</th>
              <th>
                {/* Add User Button
                <div className="icon-button" onClick={handleUserShowModal}>
                  <FontAwesomeIcon icon={faPlusCircle} />
                </div>
                */}
              </th>
            </tr>
          </thead>
          <tbody>
            {users?.map((u) => (
              <tr key={u.uuid} onClick={() => routeToUser(u.uuid)}>
                <td>{u.username}</td>
                <td>{u.email}</td>
                <td>{u.first_name}</td>
                <td>{u.last_name}</td>
                <td>{u.status}</td>
                <td>{u.is_admin || false}</td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modals */}

      <Modal show={showUserForm} modalClosed={handleUserCloseModal}>
        <div>
          <h4 className="text-center">Add User</h4>
          <hr />
        </div>
        {showUserForm && (
          <UserForm cancelForm={handleUserCloseModal} handleSubmit={handleUserSubmit} />
        )}
      </Modal>
    </div>
  );
};

export default withAuth(Users);
